import { getActionFactory } from './utils/action-class-factory';

const createAction = getActionFactory('ROOT');

export const ResetStore = createAction('RESET_STORE');
